import { Form } from 'sections/Form';

import { useForgotPassword } from './ForgotPassword.hooks';

export function ForgotPassword(): React.ReactElement {
  const {
    handleSubmit,
    register,
    getCode,
    changePassword,
    inputs,
    secondaryInputs,
    stepTwo,
    error,
  } = useForgotPassword();

  return stepTwo ? (
    <Form
      onSubmit={handleSubmit(changePassword)}
      inputs={secondaryInputs}
      buttonLabel="Create a new password"
      messageTitle="Please enter the verification code received from your email,
      and create your new password"
      register={register}
      type="forgotPassword"
      error={error}
    />
  ) : (
    <Form
      onSubmit={handleSubmit(getCode)}
      buttonLabel="Send a code"
      messageTitle="You will receive a password reset code on your email"
      inputs={inputs}
      register={register}
      type="forgotPassword"
      error={error}
      hasBackButton
    />
  );
}
